import { render, staticRenderFns } from "./InterventionModalDisplay.vue?vue&type=template&id=bef42796"
import script from "./InterventionModalDisplay.vue?vue&type=script&lang=ts"
export * from "./InterventionModalDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports